import { REGEX_IPV4_WITH_MASK_OR_PATTERN } from '@sigma-legacy-libs/essentials/lib/constants/regexp'

export const complex = {
  props: {
    complex: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      valid: [],
      invalid: []
    }
  },

  methods: {
    watchProxyHandler() {
      if (this.complex) {
        return
      } else {
        this.check()
      }

      this.transmitValue()
    },

    preCheck() {
      this.clear()
    },
    check() {
      this.preCheck()
      if (this.proxy) {
        if (typeof this.proxy === 'string') {
          const list = this._outputFilter(this.proxy)
          for (const ip of list) {
            if (REGEX_IPV4_WITH_MASK_OR_PATTERN.test(ip)) {
              this.valid.push(ip)
            } else {
              this.invalid.push(ip)
            }
          }
        }
      }
      this.postCheck()
    },
    postCheck() {
      if (this.complex) {
        this.proxy = this._inputFilter(this.valid)
        if (this.invalid.length) {
          this.showDialog = true
        } else {
          this.emit(this.valid)
        }
      }
    },

    clear() {
      this.valid.splice(0)
      this.invalid.splice(0)
    },

    reset() {
      this.proxy = undefined
      this.clear()
      this.emit()
    }
  }
}
